// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero_hero__2AzZj","heroImg":"hero_heroImg__3UtEh","heroCaption":"hero_heroCaption__1yx4t","heading":"hero_heading__CFio0","description":"hero_description__1TJcN"};